import React from 'react';
import { Step, Stepper, StepLabel } from '@material-ui/core';
import '../assets/styles/CircularProgressBar.css';

const CircularProgressBar = ({ currentStep }) => {
  const stepLabels = ['Set Subject', 'Select Comparables', 'Analyze', 'Estimate'];

  return (
    <div className="progress-bar-container">
      <Stepper activeStep={currentStep - 1} alternativeLabel>
        {stepLabels.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

export default CircularProgressBar;
